import React, {Component } from 'react';
import {Row, Col, ThemeProvider} from 'react-bootstrap';
import { Form, Input, Button, Spin , Modal, Result } from 'antd';
import {  } from '@ant-design/icons';
import './../../login.css';
import mHelper from './../config/Helper';
import mLoginController from './../control/Login/index.controllers'


const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 24 },
};

const tailLayout = {
    wrapperCol: { offset: 0, span: 0 },
};

var thisComponent;
class RequestForgotPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            message : "",
            success : false,
            loading : false
        }
        thisComponent = this;
    }   


    async componentDidMount() {
       
    }

    onFinish = values => {
        console.log(values);
        this.setState({loading : true});
        mLoginController.FORGOT_PASS_REQ(values.email,(r)=>{
            if(r.success == false){
                this.setState({message : r.message, loading:false});
            }else{
                this.setState({success:true, message : r.message, loading:false});
            }
        });
    }       

    onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    onGoToLogin = () => {
        document.location.href = `${process.env.PUBLIC_URL}/login`;
    }


    render() {
        return (
            <div>
                <div className="login-content">
                    <div className="login-main" style={{height:800}}>
                        <Row className="margin-nol ">
                            <Col sm={12} lg={2} ></Col>
                            <Col sm={12} lg={8} >

                                {this.state.success == false ?
                                    <Row className="padding-top-50">
                                        <Col sm={12} className="align-items-center justify-content-center " lg={7}>
                                        
                                        </Col>
                                        <Col sm={12} lg={5}>
                                            <Spin spinning={this.state.loading}>
                                                <div className="login-form text-center rounded">
                                                    <div className="contact-top">
                                                        <h5 className="text-secondary fw-3 py-3">
                                                            Reset Password
                                                        </h5>
                                                    </div>
                                                    <Form
                                                        {...layout}
                                                        name="basic"
                                                        initialValues={{ remember: true }}
                                                        onFinish={this.onFinish}
                                                        onFinishFailed={this.onFinishFailed}
                                                    >
                                                        <Form.Item
                                                            label=""
                                                            name="email"
                                                            rules={[{ type:"email" ,  required: true, message: 'Please input your email!' }]}
                                                        >
                                                            <Input  placeholder="Email" className="text-login"/>
                                                        </Form.Item>

                                                        <button className="btn btn-bordered w-100  btn-login" type="submit">Send Me Instruction</button>

                                                    </Form>
                                                    <div style={{marginTop:10,textAlign:"center"}}>
                                                        {this.state.message}
                                                    </div>
                                                </div>
                                            </Spin>
                                        </Col>
                                    </Row> :
                                    <div style={{marginTop:20}}>
                                        <div className="login-form text-center rounded" >
                                            <Result
                                                status="success"
                                                title="Berhasil Melakukan Lupa Password !"
                                                subTitle="Tolong, segera lihat email Anda untuk melakukan proses selanjutnya !"
                                                extra={[
                                                <Button type="primary" key="console" onClick={this.onGoToLogin}>
                                                    Go Login
                                                </Button>
                                                ]}
                                            />
                                        </div>
                                    </div>
                                }
                            </Col>
                            <Col sm={12} lg={2} >

                            </Col>
                        </Row>
                    </div>
                    <div className="shape-bottom">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"><path className="shape-fill" fill="#FFFFFF" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7  c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4  c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path></svg>
                    </div>
                </div>
                <div>
                    <Row className="margin-nol ">
                        <Col sm={12} lg={2} ></Col>
                        <Col sm={12} lg={8} >
                            <span className="d-inline-block fw-5 px-4 py-2 mb-3">
                                <span className="text-primary">2020 &copy; Link Aja  </span> 
                            </span>
                        </Col>
                        <Col sm={12} lg={2} ></Col>
                    </Row>
                </div>
            </div>
        )
    }


}

export default RequestForgotPassword;
